<script>
  import Portal from 'svelte-portal';
  import { Copy, RotateCcw, Trash2, SquareCheckBig as CheckSquare, Forward, Reply, Pin, PinOff } from 'lucide-svelte';

  export let visible = false;
  export let ready = true;
  export let menuRef = null;
  export let x = 0;
  export let y = 0;
  export let mode = 'full';
  export let isMine = false;
  export let isPinned = false;
  export let selectionMode = false;
  export let selectedCount = 0;
  export let onShare = () => {};
  export let onReply = () => {};
  export let onTogglePin = () => {};
  export let onCopy = () => {};
  export let onSelectMany = () => {};
  export let onRecall = () => {};
  export let onDelete = () => {};
  export let onClearSelection = () => {};
</script>

<Portal>
  {#if visible}
    <div
      bind:this={menuRef}
      class="context-menu fixed z-[9999] w-[218px] max-w-[calc(100vw-1.25rem)] max-h-[calc(100vh-1.25rem)] overflow-y-auto rounded-xl border border-gray-200 bg-white text-[12.5px] shadow-xl"
      style="top:{y}px; left:{x}px; visibility:{ready ? 'visible' : 'hidden'}; pointer-events:{ready ? 'auto' : 'none'}"
      on:pointerdown|preventDefault
      on:click|stopPropagation>
      {#if mode === 'full'}
        <button class="menu-item flex items-center gap-2" type="button" on:click={onShare}>
          <Forward size="15" />
          <span>Chia sẻ tin nhắn</span>
        </button>

        <button class="menu-item flex items-center gap-2" type="button" on:click={onReply}>
          <Reply size="15" />
          <span>Trả lời</span>
        </button>
      {/if}

      {#if mode === 'details'}
        <div class="px-3 py-2 text-[11px] text-slate-500">Thao tác nhanh</div>
      {/if}

      <button
        class="menu-item flex items-center gap-2 {isPinned ? 'text-rose-600 hover:bg-rose-50' : ''}"
        type="button"
        on:click={onTogglePin}>
        {#if isPinned}
          <PinOff size="15" />
          <span>Bỏ ghim tin nhắn</span>
        {:else}
          <Pin size="15" />
          <span>Ghim tin nhắn</span>
        {/if}
      </button>

      <button class="menu-item flex items-center gap-2" type="button" on:click={onCopy}>
        <Copy size="15" />
        <span>Sao chép</span>
      </button>

      <button class="menu-item flex items-center gap-2" type="button" on:click={onSelectMany}>
        <CheckSquare size="15" />
        <span>Chọn nhiều</span>
      </button>

      {#if isMine}
        <div class="my-1 h-px bg-gray-200"></div>

        <button class="menu-item flex items-center gap-2 text-amber-600 hover:bg-amber-50" type="button" on:click={onRecall}>
          <RotateCcw size="15" />
          <span>Thu hồi tin nhắn</span>
        </button>

        <button class="menu-item flex items-center gap-2 text-red-600 hover:bg-red-50" type="button" on:click={onDelete}>
          <Trash2 size="15" />
          <span>Xoá tin nhắn</span>
        </button>
      {/if}

      {#if selectionMode}
        <div class="my-1 h-px bg-gray-200"></div>

        <div class="px-3 py-2 text-xs text-gray-500">
          Đã chọn <span class="font-semibold text-gray-700">{selectedCount}</span> tin nhắn
        </div>

        <button class="menu-item flex items-center gap-2 text-blue-600 hover:bg-blue-50" type="button" on:click={onClearSelection}>
          <RotateCcw size="15" />
          <span>Bỏ chọn</span>
        </button>
      {/if}
    </div>
  {/if}
</Portal>

<style>
  .menu-item {
    width: 100%;
    padding: 8px 12px;
    text-align: left;
    line-height: 1.08;
    font-size: 0.82rem;
    letter-spacing: 0.01em;
  }

  .context-menu,
  .context-menu * {
    -webkit-touch-callout: none;
    -webkit-user-select: none;
    user-select: none;
  }

  .menu-item:hover {
    background: rgba(0, 0, 0, 0.06);
  }
</style>
